const propertyName = window.general?.selection_title || "Selected Fabric";

function waitForPubSub(callback) {
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    callback();
  } else {
    setTimeout(() => waitForPubSub(callback), 50);
  }
}

waitForPubSub(() => {
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
    const target = payload?.data?.target;
    if (!target) return;

    const isFabric = target.closest(".fabric__block");
    if (!isFabric) return;

    const selectedFabric = target.value.trim();
    const targetTabId =
      "fabric-" + selectedFabric.toLowerCase().replace(/\s+/g, "-");

    const mediaBlock = document.querySelector("#fabric__block");
    const mainMedia = document.querySelector(
      ".customizer_media, .main_media_element"
    );
    const targetContent = document.querySelector(`#${targetTabId}`);

    document
      .querySelectorAll(".option_media_block")
      .forEach((b) => b.classList.remove("active"));
    document
      .querySelectorAll(".customizer-tab-content")
      .forEach((c) => c.classList.remove("active"));
    document
      .querySelectorAll(".customizer-tab-item.selected")
      .forEach((i) => i.classList.remove("selected"));

    if (mediaBlock) mediaBlock.classList.add("active");
    // document.querySelector("body").classList.add("scroll-hidden");
    if (mainMedia) mainMedia.classList.add("active");

    if (targetContent) {
      targetContent.classList.add("active");
      const first = targetContent.querySelector(".customizer-tab-item");
      if (first) first.classList.add("selected");
    }
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
    const savedTitle = window._fabricSummaryTitle;
    const savedDescription = window._fabricSummaryDescription;

    if (!savedTitle) return;

    const fabricBlock = document.querySelector(".fabric__block");
    if (!fabricBlock) return;

    let box = fabricBlock.querySelector(".fabric-summary");
    if (!box) {
      box = document.createElement("div");
      box.className = "fabric-summary";
      fabricBlock.appendChild(box);
    }
    box.innerHTML = `<strong>${savedTitle}</strong><div>${savedDescription}</div>`;
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function () {
    const savedTitle =
      window._fabricSummaryTitle || localStorage.getItem("fabricSummaryTitle");
    if (!savedTitle) return;

    // Restore hidden input too
    const buttons = document.querySelector(".product-form__buttons");
    if (buttons) {
      let input = document.querySelector(
        `input[name='properties[${propertyName}]']`
      );
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${propertyName}]`;
        buttons.insertAdjacentElement("beforebegin", input);
      }
      input.value = savedTitle;
    }
  });
});

/* ======================
   Delegated handlers for buttons and items (survive DOM replacement)
   - .btn_view: open vertical Swiper popup
   - .btn_select: apply selection to target block summary and close media
   - .customizer-tab-item click: toggle selected class
   ====================== */

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".btn_view, .btn_select, .customizer-tab-item");
  if (!btn) return;

  // ======================
  // .btn_view handler (delegated)
  // ======================
  if (btn.matches(".btn_view")) {
    e.stopPropagation();
    const parentItem = btn.closest(".customizer-tab-item");
    if (!parentItem) return;

    // Parse data-img (JSON array). If parsing fails, fallback to background-image
    let imgs = [];
    const raw = parentItem.getAttribute("data-img") || "";
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) imgs = parsed;
    } catch (_) {
      // ignore
    }
    if (!imgs.length) {
      const bg = parentItem.style.backgroundImage || "";
      const m = bg.match(/url\(["']?(.*?)["']?\)/i);
      if (m && m[1]) imgs = [m[1]];
    }
    if (!imgs.length) return;

    // Build overlay + wrapper
    const overlay = document.createElement("div");
    overlay.className = "image-popup-overlay";

    const wrapper = document.createElement("div");
    wrapper.className = "image-popup-wrapper";

    const closeBtn = document.createElement("button");
    closeBtn.className = "image-popup-close";
    closeBtn.innerHTML = "&times;";

    const swiperEl = document.createElement("div");
    swiperEl.className = "swiper popup-swiper";
    swiperEl.style.width = "90vw";
    swiperEl.style.maxWidth = "900px";
    swiperEl.style.height = "90vh";

    const track = document.createElement("div");
    track.className = "swiper-wrapper";

    imgs.forEach((src) => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      const img = document.createElement("img");
      img.src = src;
      img.alt = "Preview";
      img.className = "image-popup-img";
      slide.appendChild(img);
      track.appendChild(slide);
    });

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";

    swiperEl.appendChild(track);
    swiperEl.appendChild(pagination);

    wrapper.appendChild(closeBtn);
    wrapper.appendChild(swiperEl);
    overlay.appendChild(wrapper);
    document.body.appendChild(overlay);

    requestAnimationFrame(() => overlay.classList.add("active"));
    document.body.style.overflow = "hidden";

    // Init Swiper (vertical). Assumes Swiper library is available on the page.
    let popupSwiper;
    try {
      popupSwiper = new Swiper(swiperEl, {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 10,
        mousewheel: true,
        allowTouchMove: true,
        autoHeight: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    } catch (err) {
      console.warn("Swiper init failed for popup", err);
    }

    const closePopup = () => {
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      if (popupSwiper && popupSwiper.destroy) {
        popupSwiper.destroy(true, true);
      }
      setTimeout(() => overlay.remove(), 250);
    };

    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", (evt) => {
      if (evt.target === overlay) closePopup();
    });
    document.addEventListener(
      "keydown",
      function escListener(evt) {
        if (evt.key === "Escape") {
          closePopup();
          document.removeEventListener("keydown", escListener);
        }
      },
      { once: true }
    );

    return;
  }

  // ======================
  // .btn_select handler (delegated)
  // ======================

  if (btn.matches(".btn_select")) {
    e.stopPropagation();

    const item = btn.closest(".customizer-tab-item");
    if (!item) return;

    const title = item.dataset.title || "";
    const description = item.dataset.description || "";

    // Save for restoring after Dawn reload
    window._fabricSummaryTitle = title;
    window._fabricSummaryDescription = description;

    localStorage.setItem("fabricSummaryTitle", title);
    localStorage.setItem("fabricSummaryDescription", description);

    // Clear active classes
    document
      .querySelectorAll(".active, .customizer-tab-item.selected")
      .forEach((el) => el.classList.remove("active", "selected"));
    // document.querySelector("body").classList.remove("scroll-hidden");

    // Update summary inside fabric__block
    const block = document.querySelector(".fabric__block");
    if (block) {
      let box = block.querySelector(".fabric-summary");
      if (!box) {
        box = document.createElement("div");
        box.className = "fabric-summary";
        block.appendChild(box);
      }
      box.innerHTML = `<strong>${title}</strong><div>${description}</div>`;
    }

    // Hidden input for line item properties
    const buttons = document.querySelector(".product-form__buttons");

    if (buttons) {
      let input = document.querySelector(
        `input[name='properties[${propertyName}]']`
      );
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${propertyName}]`;
        buttons.insertAdjacentElement("beforebegin", input);
      }
      input.value = title;
    }

    return;
  }

  // ======================
  // .customizer-tab-item click handler (delegated)
  // ======================
  if (btn.matches(".customizer-tab-item")) {
    // allow the click; just toggle selected class inside its option_media_block
    const item = btn;
    const block = item.closest(".option_media_block");
    if (!block) return;

    block
      .querySelectorAll(".customizer-tab-item.selected")
      .forEach((i) => i.classList.remove("selected"));
    item.classList.add("selected");

    return;
  }
});

/* ===========
   Initialization helpers (optionally run when this script loads)
   If you need to run some setup when the page loads, put it here.
   For example: register any default states based on currently selected radios.
   =========== */

// Restore fabric summary on first page load
(function restoreOnLoad() {
  const title = localStorage.getItem("fabricSummaryTitle");
  const desc = localStorage.getItem("fabricSummaryDescription");

  if (!title) return; // no saved fabric yet

  const fabricBlock = document.querySelector(".fabric__block");
  if (!fabricBlock) return;

  let box = fabricBlock.querySelector(".fabric-summary");
  if (!box) {
    box = document.createElement("div");
    box.className = "fabric-summary";
    fabricBlock.appendChild(box);
  }

  box.innerHTML = `<strong>${title}</strong><div>${desc}</div>`;
})();

(function restoreHiddenInput() {
  const title = localStorage.getItem("fabricSummaryTitle");
  if (!title) return;

  const buttons = document.querySelector(".product-form__buttons");
  if (!buttons) return;

  let input = document.querySelector(
    `input[name='properties[${propertyName}]']`
  );
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${propertyName}]`;
    buttons.insertAdjacentElement("beforebegin", input);
  }

  input.value = title;
})();


// Allow clicking an already-selected fabric option to reopen media
document.addEventListener("click", function (e) {
  const radio = e.target.closest('.fabric__block input[type="radio"]');
  if (!radio) return;

  // If radio is already selected, Dawn normally does nothing → we force it
  if (radio.checked) {
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event: new Event("change"),
        target: radio,
        selectedOptionValues: [radio.value],
      },
    });

    // Restore fabric UI summary
    const title =
      window._fabricSummaryTitle || localStorage.getItem("fabricSummaryTitle");
    const desc =
      window._fabricSummaryDescription ||
      localStorage.getItem("fabricSummaryDescription");

    const fabricBlock = document.querySelector(".fabric__block");
    if (fabricBlock && title) {
      let box = fabricBlock.querySelector(".fabric-summary");
      if (!box) {
        box = document.createElement("div");
        box.className = "fabric-summary";
        fabricBlock.appendChild(box);
      }
      box.innerHTML = `<strong>${title}</strong><div>${desc}</div>`;
    }
  }
});